'use strict';

/**
 * Close a specific dropdown
 * @param {Element} dropdown - The dropdown to close
 */
function closeDropdown(dropdown) {
    if (!dropdown) return;

    $(dropdown).removeClass('show');
    const button = dropdown.querySelector('.display-value-wrapper');
    if (button) {
        button.setAttribute('aria-expanded', 'false');
    }
}

/**
 * Close all open dropdowns
 * @param {Element} exceptDropdown - Optional dropdown to exclude from closing
 */
function closeAllDropdowns(exceptDropdown) {
    const openDropdowns = document.querySelectorAll('.custom-dropdown.show');
    openDropdowns.forEach(function (dropdown) {
        if (dropdown !== exceptDropdown) {
            closeDropdown(dropdown);
        }
    });
}

/**
 * Open a specific dropdown
 * @param {Element} dropdown - The dropdown to open
 */
function openDropdown(dropdown) {
    if (!dropdown) return;

    $(dropdown).addClass('show');
    const button = dropdown.querySelector('.display-value-wrapper');
    if (button) {
        button.setAttribute('aria-expanded', 'true');
    }

    // Focus on first menu item
    const firstMenuItem = dropdown.querySelector('ul[role="menu"] li[role="menuitemradio"]');
    if (firstMenuItem) {
        firstMenuItem.setAttribute('tabindex', '0');
        firstMenuItem.focus();
    }
}

/**
 * Get all focusable menu items within a dropdown
 * @param {Element} dropdown - The dropdown element
 * @return {Array} Array of menu item elements
 */
function getMenuItems(dropdown) {
    if (!dropdown) return [];
    return Array.from(dropdown.querySelectorAll('ul[role="menu"] li[role="menuitemradio"]'));
}

var updateCustomDropdown = function ($customDropdown, $selectedOption) {
    const selectedValue = $selectedOption.innerText.trim();
    const getShortDisplay = $selectedOption.getAttribute('short-display');
    const getOptionValue = $selectedOption.getAttribute('value');
    const $displayValueElement = $customDropdown.querySelector('.display-value');
    const shortDisplay = getShortDisplay && getShortDisplay.trim();
    const optionValue = getOptionValue && getOptionValue.trim();

    /* eslint-disable no-param-reassign */
    $displayValueElement.innerText = shortDisplay || selectedValue;
    $customDropdown.querySelector('input[type="hidden"]').value = optionValue || selectedValue;
    $customDropdown.value = optionValue || selectedValue;
    /* eslint-enable no-param-reassign */

    if (optionValue) {
        $customDropdown.classList.add('option-selected');
    } else {
        $customDropdown.classList.remove('option-selected');
    }
};

var defaultSelectedOption = function () {
    const $allSelectedOptions = document.querySelectorAll('.custom-dropdown li[selected]');

    $allSelectedOptions.forEach($selectedOption => {
        const $customDropdown = $selectedOption.closest('.custom-dropdown');
        updateCustomDropdown($customDropdown, $selectedOption);
    });
};

/**
 * Handle arrow key navigation within menu
 * @param {KeyboardEvent} evt - The keyboard event
 * @param {Element} dropdown - The dropdown element
 */
function handleArrowKeyNavigation(evt, dropdown) {
    const menuItems = getMenuItems(dropdown);
    if (menuItems.length === 0) return;

    const currentIndex = menuItems.findIndex(item => item === document.activeElement);
    let nextIndex;

    if (evt.key === 'ArrowDown' || evt.keyCode === 40) {
        evt.preventDefault();
        nextIndex = currentIndex < menuItems.length - 1 ? currentIndex + 1 : 0; // Cycle to first
    } else if (evt.key === 'ArrowUp' || evt.keyCode === 38) {
        evt.preventDefault();
        nextIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1; // Cycle to last
    }

    if (nextIndex !== undefined) {
        // Update tabindex
        menuItems.forEach(function (item, index) {
            item.setAttribute('tabindex', index === nextIndex ? '0' : '-1');
        });
        menuItems[nextIndex].focus();
    }
}

var initEventListener = function () {
    // Handle button clicks and keyboard activation
    $(document).on('click keydown', '.custom-dropdown .display-value-wrapper', function (evt) {
        if (evt.type === 'keydown' && !(/^(13|32)$/).test(evt.which)) {
            return;
        }

        evt.preventDefault();
        const customDropdown = evt.target.closest('.custom-dropdown');
        const isOpen = customDropdown.classList.contains('show');

        // Close other dropdowns
        closeAllDropdowns(customDropdown);

        // Toggle this dropdown
        if (isOpen) {
            closeDropdown(customDropdown);
        } else {
            openDropdown(customDropdown);
        }
    });

    // Global ESC key handler for screen reader compatibility
    $(document).on('keydown', function (evt) {
        if (evt.key === 'Escape' || evt.keyCode === 27) {
            const activeDropdown = document.querySelector('.custom-dropdown.show');
            if (activeDropdown) {
                evt.preventDefault();
                evt.stopPropagation();
                closeDropdown(activeDropdown);
                const button = activeDropdown.querySelector('.display-value-wrapper');
                if (button) {
                    button.focus();
                }
            }
        }
    });

    // Handle keyboard navigation within menu
    $(document).on('keydown', '.custom-dropdown ul[role="menu"] li[role="menuitemradio"]', function (evt) {
        const customDropdown = evt.target.closest('.custom-dropdown');
        const customOptions = evt.target.closest('li');

        // ESC key - close menu and return focus to button
        if (evt.key === 'Escape' || evt.keyCode === 27) {
            evt.preventDefault();
            closeDropdown(customDropdown);
            const button = customDropdown.querySelector('.display-value-wrapper');
            if (button) {
                button.focus();
            }
            return;
        }

        // Tab and Shift+Tab - navigate through menu items
        if (evt.key === 'Tab' || evt.keyCode === 9) {
            evt.preventDefault();
            const menuItems = getMenuItems(customDropdown);
            if (menuItems.length === 0) return;

            const currentIndex = menuItems.findIndex(item => item === document.activeElement);
            let nextIndex;

            if (evt.shiftKey) {
                // Shift+Tab - go to previous item (cycle to last)
                nextIndex = currentIndex > 0 ? currentIndex - 1 : menuItems.length - 1;
            } else {
                // Tab - go to next item (cycle to first)
                nextIndex = currentIndex < menuItems.length - 1 ? currentIndex + 1 : 0;
            }

            // Update tabindex
            menuItems.forEach(function (item, index) {
                item.setAttribute('tabindex', index === nextIndex ? '0' : '-1');
            });
            menuItems[nextIndex].focus();
            return;
        }

        // Arrow keys - navigate through menu items
        if (evt.key === 'ArrowDown' || evt.keyCode === 40 || evt.key === 'ArrowUp' || evt.keyCode === 38) {
            handleArrowKeyNavigation(evt, customDropdown);
            return;
        }

        // Enter or Space - select option and close menu
        if (evt.key === 'Enter' || evt.keyCode === 13 || evt.key === ' ' || evt.keyCode === 32) {
            evt.preventDefault();

            if (customOptions && customOptions.hasAttribute('disabled')) {
                return;
            }

            if (!customOptions.hasAttribute('selected')) {
                // Remove selected attribute from other options
                const allOptions = customDropdown.querySelectorAll('[selected]');
                allOptions.forEach(function (item) {
                    item.removeAttribute('selected');
                    item.setAttribute('aria-checked', 'false');
                });

                // Set new selection
                customOptions.setAttribute('selected', true);
                customOptions.setAttribute('aria-checked', 'true');
                updateCustomDropdown(customDropdown, customOptions);

                // Dispatch custom change event
                customDropdown.dispatchEvent(new CustomEvent('custom-dropdown:change', {
                    bubbles: true,
                    detail: {
                        $selectedOption: customOptions
                    }
                }));
            }

            // Close menu and return focus to button
            closeDropdown(customDropdown);
            const button = customDropdown.querySelector('.display-value-wrapper');
            if (button) {
                button.focus();
            }
        }
    });

    // Handle menu item clicks
    $(document).on('click', '.custom-dropdown ul[role="menu"] li[role="menuitemradio"]', function (evt) {
        evt.preventDefault();
        const customDropdown = evt.target.closest('.custom-dropdown');
        const customOptions = evt.target.closest('li');

        if (!customDropdown || !customOptions) {
            return;
        }

        if (customOptions.hasAttribute('disabled')) {
            return;
        }

        if (!customOptions.hasAttribute('selected')) {
            // Remove selected attribute from other options
            const allOptions = customDropdown.querySelectorAll('[selected]');
            allOptions.forEach(function (item) {
                item.removeAttribute('selected');
                item.setAttribute('aria-checked', 'false');
            });

            // Set new selection
            customOptions.setAttribute('selected', true);
            customOptions.setAttribute('aria-checked', 'true');
            updateCustomDropdown(customDropdown, customOptions);

            // Dispatch custom change event
            customDropdown.dispatchEvent(new CustomEvent('custom-dropdown:change', {
                bubbles: true,
                detail: {
                    $selectedOption: customOptions
                }
            }));
        }

        closeDropdown(customDropdown);
    });

    // Close dropdown when clicking outside
    $(document).on('click', function (evt) {
        if (!evt.target.closest('.custom-dropdown')) {
            closeAllDropdowns();
        }
    });
};

var initCustomDropdown = function () {
    initEventListener();

    window.addEventListener('DOMContentLoaded', () => {
        defaultSelectedOption();
    });
};

initCustomDropdown();
